﻿import { ApiCaller, FullfilledApiResponse } from 'apis/ApiCaller';
import { getFormattedDateApi } from 'utils';
import { License } from 'apis/LicenseApi';
import { Partner } from 'apis/PartnerApi';

export enum OrderStatus {
    AllOrders,
    Pending,
    Processed,
    Canceled
}
export interface Order {
	Active: boolean;
	AllowRetract: boolean;
	CodeCount: number;
	CodesRedeemed: number;
	Comment: string;
	CourseUses: number;
	DateCreate: string;
	DateExpire: string;
	DateStart: string;
	EbookUses: number;
	FilledByPartnerName: string;

	// Legacy code made me
	ID: number;
	Id: number;
	IsOffline: boolean;
	License: License;
	Name: string;
	NumAvailable: number;
	NumGranted: number;
	NumRequested: number;
	OrderControl: string;
	OrderedBy: string;
	OrderStatus: OrderStatus;
	OrderStatusText: string;
	Partner: Partner;
	PracticeTestUses: number;
	PreviousControl: string;
	PreviousId: number;
	PurchaseOrder: string;
	RenewedControl: string;
	RenewId: number;
	UsesByType: string;
}

export interface OrderInventory {
	Id: number;
	Inventory: number;
}

export enum AutoFillOptionType {
	No = 0,
	Inventory = 1,
	NewOrder = 2,
}

export type OrderUseRecord = {
	Comment: string;
	DeliverableTypeId: number;
	DeliverableTypeName: string;
	Id: number; //Order Id
	LicenseId: number;
	MaxUses: string;
	NumGranted: number;
	OrderId: number;
	TotalRedemptions: string;
	UniqueUsers: number;
	UsesRemaining: number;
}

export class OrderApi {

    private static apiCaller = new ApiCaller('Orders');

    public static GetAll(partnerId: number, orderStatus: number, recieved: boolean, cultureId = 1): Promise<Order[]> {

	    return this.apiCaller.GET<Order[]>('GetAll', { cultureId, orderStatus, partnerId, recieved });

    }

    public static Update(orderId: number, comment: string, daysToAddStart: number, daysToAddExpiration: number): Promise<FullfilledApiResponse> {

	    return this.apiCaller.POST<FullfilledApiResponse>('Update', { comment, daysToAddExpiration, daysToAddStart, orderId });

    }

    public static GetOrderInventory(partnerId: number): Promise<OrderInventory[]> {

	    return this.apiCaller.GET<OrderInventory[]>('GetOrderInventory', { partnerId });

    }

    public static GetOrderUseRecords(orderId: number, cultureId: number): Promise<OrderUseRecord[]> {

	    return this.apiCaller.POST<OrderUseRecord[]>('GetOrderUseRecords', { cultureId, orderId });

    }

    public static UpdateUsesRemainingRecord(orderId: number, deliverableTypeId: number, deliverableTypeName: string, uses: number, cultureId: number): Promise<FullfilledApiResponse> {

	    return this.apiCaller.POST<FullfilledApiResponse>('UpdateUsesRemainingRecord', { comment: `Changed ${deliverableTypeName} uses to ${uses}.`, cultureId, deliverableTypeId, orderId, uses });

    }

    public static RetractOrder(orderId: number) {

	    return this.apiCaller.POST('RetractOrder', { orderId });

    }

    public static PlaceOrder(
	    partnerId: number,
	    licenseId: number,
	    numRequested: number,
	    isAutoFill: AutoFillOptionType,
	    orderIdToAutoFill: number,
	    startDate: Date,
	    purchaseOrder: string,
	    comment: string,
	    isOffline: boolean,
	    renewId: number
    ): Promise<FullfilledApiResponse> {

	    return this.apiCaller.POST('PlaceOrder', {
	        comment,
	        isAutoFill,
	        isOffline,
	        licenseId,
	        numRequested,
	        orderIdToAutoFill,
	        partnerId,
	        purchaseOrder,
	        renewId,
	        startDate: getFormattedDateApi(startDate)
	    });

    }

    public static FillOrder(orderId: number, partnerId: number, purchaseOrder = '', comment = '') {

	    const dataObj: any = {
	        orderId,
	        partnerId
	    };
	    if (purchaseOrder.length > 0) {

	        dataObj.purchaseOrder = purchaseOrder;

	    }
	    if (comment) {

	        dataObj.comment = comment;

	    }
	    return this.apiCaller.POST('FillOrder', {
	        ...dataObj
	    });

    }

    public static UpdateComment(orderId: number, comment: string) {

	    return this.apiCaller.POST('UpdateComment', { comment, orderId });

    }

    public static UpdatePurchaseOrder(orderId: number, purchaseOrder: string) {

	    return this.apiCaller.POST('UpdatePurchaseOrder', { orderId, purchaseOrder });

    }

    public static GetOrderDetails(orderId: number): Promise<Order> {

	    return this.apiCaller.GET<Order>('GetOrderDetails', { orderId });

    }

    public static GetMyInventory(partnerId: number, isTestingCenter: boolean, cultureId = 1): Promise<Order[]> {

	    return this.apiCaller.GET<Order[]>('GetMyInventory', { cultureId, isTestingCenter, partnerId });

    }

    public static CancelOrder(orderId: number, comment = ''): Promise<FullfilledApiResponse> {

	    return this.apiCaller.POST<FullfilledApiResponse>('CancelOrder', { comment, orderId });

    }

}
